/* @flow strict */

import * as React from 'react';
import './dropdown.scss';

type PropsType = {
    options: [],
    placeholder?: string,
    onChange: () => void
};

const CheckboxDropdown = (props: PropsType): React.Element<'div'> => {
    const { options, placeholder, onChange } = props;
    const [isOpen, setOpen] = React.useState(false);
    const [caption, setCaption] = React.useState('');
    const [checkList, setCheckList] = React.useState({});
    const optionsRef = React.useRef();

    const checkItem = (e: {}) => {
        e.persist();
        setCheckList((state: {}): void => {
            const array = state[e.target.name];

            if (Array.isArray(array)) {
                const index = array.findIndex((val: string): number => val === e.target.value);

                if (index !== -1) {
                    array.splice(index, 1);
                    return { [e.target.name]: array };
                }

                return { [e.target.name]: [...array, e.target.value] };
            }
            return { [e.target.name]: [e.target.value] };
        });
    };

    React.useEffect(() => {
        onChange(checkList);
        renderCaption(checkList);
    }, [checkList]);

    const renderCaption = (obj: {}) => {
        const arr = Object.values(obj)[0];

        if (!arr) return;
        if (arr.length > 1) {
            setCaption(`${arr.length} items selected`);
        } else {
            const option = options.find((x: {}): {} => x.id === arr[0]);

            setCaption(option ? option.text : '');
        }
    };

    const closeOptions = (e: {}) => {
        if (optionsRef.current && !optionsRef.current.contains(e.target)) {
            setOpen(false);
        }
    };

    //  toggle onBlur
    React.useEffect((): void => {
        document.addEventListener('mousedown', (e: {}) => {
            closeOptions(e);
        });
        return () => {
            document.removeEventListener('mousedown', closeOptions);
        };
    }, []);

    const arrowClasses = `sparxo-checkout-dropdown_fakeArrow ${isOpen ? 'sparxo-checkout-dropdown_arrowDown' : ''}`;
    const optionClasses = `sparxo-checkout-dropdown_fakeOptions ${isOpen ? 'sparxo-checkout-dropdown_showOptions' : ''}`;

    return (
        <div className='sparxo-checkout-dropdown_container' ref={optionsRef}>
            <div style={{ position: 'relative' }}>
                <i className={arrowClasses} />
                <input
                  type="text"
                  value={caption}
                  readOnly
                  className='sparxo-checkout-dropdown_fakeSelectInput'
                  placeholder={placeholder}
                  spellCheck="false"
                  autoComplete="off"
                  onClick={(): void => setOpen((state: boolean): boolean => !state)}
                />
            </div>
            <div className={optionClasses}>
                {options.map((opt: {}): React.Element<'button'> => (
                    <label key={opt.id} htmlFor={opt.id} className='sparxo-checkout-dropdown_checkboxLabel'>
                        <button
                          type="button"
                          name={opt.question_id}
                          value={opt.id}
                          className='sparxo-checkout-dropdown_checkboxOption'
                        >
                            <input
                              type='checkbox'
                              value={opt.id}
                              id={opt.id}
                              name={opt.question_id}
                              onChange={(e: {}): void => checkItem(e)}
                            />
                            <span>{opt.text}</span>

                        </button>
                    </label>

                ))}
            </div>
        </div>
    );
};

export default CheckboxDropdown;

